/**
 * 平铺树结构
 * @param tree
 * @param childrenKey
 * @param results
 */
const flattenTree = (
  tree: any,
  childrenKey = "children",
  results: Array<any> = []
): any => {
  tree = JSON.parse(JSON.stringify(tree));
  if (Object.prototype.toString.call(tree) === "[object Array]") {
    return tree.reduce((resArr: any, child: any) => {
      return flattenTree(child, childrenKey, resArr);
    }, results);
  } else if (Object.prototype.toString.call(tree) === "[object Object]") {
    if (tree[childrenKey]) {
      const child = JSON.parse(JSON.stringify(tree[childrenKey]));
      delete tree[childrenKey];
      results.push(tree);
      return flattenTree(child, childrenKey, results);
    }
  }
  results.push(tree);
  return results;
};


export default flattenTree;